import { Injectable } from '@angular/core';
import ZipcodeSearch from '@stefanzweifel/js-swiss-cantons/src/ZipcodeSearch';

@Injectable()
export class CantonService {
  getCanton(zipcode?: string | number): string {
    return zipcode ? new ZipcodeSearch().findbyZipcode(zipcode)?.canton : undefined;
  }
}
